import { ReactComponent as EmojiNerdFace } from '@public/icons/emoji_nerdface.svg';
import Icon from '../atoms/Icon';

const IconEmojiNerdFace = (props) => <Icon as={EmojiNerdFace} {...props} />;

IconEmojiNerdFace.propTypes = Icon.propTypes;

export default IconEmojiNerdFace;
